(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atom-neon-cut-family"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('atom-neon-cut-family')) {
    customElements.define('atom-neon-cut-family', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.link = this.querySelector('[data-cut-family-link]');
        this.unavailable = this.querySelector('[data-cut-family-unavailable]');
        if (!this.link) return;
        try {
          this.data = JSON.parse(this.querySelector('[data-cut-family-data]').textContent);
        } catch {
          this.setUnavailable();
          return;
        }
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.scope = this.closest('.apdp-root');
        this.scheduleRefresh = () => {
          cancelAnimationFrame(this.refreshFrame);
          this.refreshFrame = requestAnimationFrame(() => this.refreshLink());
        };
        if (this.scope) {
          this.scope.addEventListener('input', this.scheduleRefresh, { capture: true, signal });
          this.scope.addEventListener('change', this.scheduleRefresh, { capture: true, signal });
          this.observer = new MutationObserver(this.scheduleRefresh);
          this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        }
        for (const eventName of ['pointerdown', 'focusin', 'keydown', 'contextmenu', 'click', 'auxclick']) {
          this.link.addEventListener(eventName, (event) => {
            this.refreshLink();
            if (!this.link.hasAttribute('href') && ['click', 'auxclick', 'keydown'].includes(event.type)) {
              if (event.type !== 'keydown' || event.key === 'Enter' || event.key === ' ') event.preventDefault();
            }
          }, { capture: true, signal });
        }
        window.addEventListener('pageshow', this.scheduleRefresh, { signal });
        this.refreshLink();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.refreshFrame);
      }

      setUnavailable() {
        this.link?.removeAttribute('href');
        this.link?.setAttribute('aria-disabled', 'true');
        if (this.unavailable) this.unavailable.hidden = false;
      }

      refreshLink() {
        const inputs = this.scope?.querySelectorAll('#apdp-product-form #apdpVariantId');
        if (!this.data?.valid || inputs?.length !== 1 || !Array.isArray(this.data.source) || !Array.isArray(this.data.target)) {
          this.setUnavailable();
          return;
        }
        const source = this.data.source.filter((variant) => variant.id === inputs[0].value);
        if (source.length !== 1 || !Array.isArray(source[0].options) || source[0].options.length !== 1) {
          this.setUnavailable();
          return;
        }
        const target = this.data.target.filter((variant) =>
          Array.isArray(variant.options) && variant.options.length === source[0].options.length &&
          variant.options.every((option, index) => option === source[0].options[index])
        );
        if (target.length !== 1 || !/^\d+$/.test(target[0].id)) {
          this.setUnavailable();
          return;
        }
        try {
          const url = new URL(this.data.path, window.location.origin);
          if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) throw new Error('Invalid product path');
          url.search = '';
          url.hash = '';
          url.searchParams.set('variant', target[0].id);
          const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (previewThemeId && /^\d+$/.test(previewThemeId)) url.searchParams.set('preview_theme_id', previewThemeId);
          this.link.setAttribute('href', url.pathname + url.search);
          this.link.removeAttribute('aria-disabled');
          if (this.unavailable) this.unavailable.hidden = true;
        } catch {
          this.setUnavailable();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
